import { adjustProjectReference } from 'actions/projectData/adjustProjectReference'
import { all, put, takeEvery } from 'redux-saga/effects'
import * as ActionTypes from '~/actions/ActionTypes'

function* updateReference() {
  yield put(adjustProjectReference())
}

function* watchAll() {
  yield all([
    takeEvery([
      ActionTypes.ASSET_ADDED_TO_TIMELINE,
      ActionTypes.ASSET_PREVIEW_UPDATED,
      ActionTypes.RIPPLE_DELETE_ASSETS,
      ActionTypes.DELETE_ASSETS,
      ActionTypes.RIPPLE_DELETE_ASSETS,
      ActionTypes.DELETE_IO_POINTS_TIMELINE_FRAGMENT ], updateReference),
  ])
}

export default watchAll
